import React, { useEffect, useState } from "react";
import { functions, auth } from "../firebase/firebase";
import { httpsCallable } from "firebase/functions";
import { toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import { formatToIndianNumberSystem } from "../components/NumberFormatter";

const IntrinsicValueTable = ({ stockId }) => {
  
  const [avgCashFlowGrowth, setAvgCashFlowGrowth] = useState(null);
  const [totalShares, setTotalShares] = useState(null);
  const [baseCashflowValue, setBaseCashflowValue] = useState(null);
  const [error, setError] = useState(null);

  // Fetch stock details when the component mounts or stockId changes
  useEffect(() => {
    const fetchStockDetails = async () => {

    const updateValueFn = httpsCallable(functions, "updateValue");
      
      try {
        const response = await updateValueFn({ id: stockId });
        setAvgCashFlowGrowth(response.data.avgCashFlowGrowth);
        setTotalShares(response.data.totalShares);
        setBaseCashflowValue(response.data.baseValue);
      } catch (err) {
        setError(err.message);
        console.error("Error occurred:", err);
      }
    };

    fetchStockDetails();
  }, [stockId]); // Dependency array includes stockId

  const updateIntrinsicInfirebase = async () => {
    const updateIntrinsicValueFn = httpsCallable(
      functions,
      "updateIntrinsicValue"
    );
    const payload = { id: stockId };

    try {
      const response = await updateIntrinsicValueFn(payload);
      if (response.data.success) {
        toast.success("Update IntrinsicValue successful!", {
          position: "top-center",
        });
      } else {
         toast.error("Failed to update. Please try again.", {
           position: "top-center",
         });
      }
    } catch (error) {
      console.error("Error updating intrinsic value:", error);
      toast.error("Error updating intrinsic value.", {
       position: "top-center",
     });
    }
  };

  const downloadFinancialsFromWeb = async () => {
    const downloadFinancialsFn = httpsCallable(functions, "main");
    // const payload = { id: stockId };
     const user = auth.currentUser;
     if (!user) {
       throw new Error("User is not authenticated.");
     }

     const idToken = await user.getIdToken(); // Fetch the token
     console.log("ID Token:", idToken);

    try {
      const response = await downloadFinancialsFn(
        { id: stockId },
        {
          headers: {
            Authorization: `Bearer ${idToken}`, // Include the token here
          },
        }
      );
      if (response.data.success) {
        toast.success("Financials downloaded successfully!", {
          position: "top-center",
        });
      } else {
         toast.error("Failed to download financials. Please try again.", {
           position: "top-center",
         });
      }
    } catch (error) {
      console.error("Error downloading financials:", error);
      toast.error("Error downloading financials.", {
      position: "top-center",
    });
    }
  };




  return (
    <table className="min-w-full table-auto border border-gray-300">
      <tbody>
        <tr className="bg-gray-100">
          <td className="px-4 py-2 border border-gray-300  text-xs ">
            Update intrinsic value:
          </td>
          <td className="px-4 py-2 border border-gray-300  text-xs text-right">
            <button
              className="text-blue-700 hover:underline  text-xs"
              onClick={updateIntrinsicInfirebase}
            >
              Update
            </button>
          </td>
          <td className="px-4 py- text-right border border-gray-300 ">
            <button
              className="text-blue-700 hover:underline ml-10  text-xs "
              onClick={downloadFinancialsFromWeb}
            >
              Get Latest Financials
            </button>
          </td>
        </tr>
        <tr className="odd:bg-gray-100 even:bg-white  text-xs">
          <td className="px-4 py-2 border border-gray-300  text-xs">
            Average Growth Rate (%) :
          </td>
          <td className="px-4 py-2 border border-gray-300  text-xs text-right">
            {avgCashFlowGrowth !== null ? avgCashFlowGrowth.toFixed(2) : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-gray-100 even:bg-white  text-xs">
          <td className="px-4 py-2 border border-gray-300">
            Base Cashflow Value (Cr) :
          </td>
          <td className="px-4 py-2 border border-gray-300 text-right">
            {baseCashflowValue !== null 
            ?formatToIndianNumberSystem( baseCashflowValue.toFixed(2)) : "N/A"}
          </td>
        </tr>
        <tr className="odd:bg-gray-100 even:bg-white  text-xs">
          <td className="px-4 py-2 border border-gray-300">Shares</td>
          <td className="px-4 py-2 border border-gray-300 text-right">
            {totalShares !== null ? formatToIndianNumberSystem(totalShares.toFixed(2)) : "N/A"}
          </td>
        </tr>
        {error && (
          <tr className="odd:bg-gray-100 even:bg-white">
            <td
              colSpan="2"
              className="px-4 py-2 text-red-500 border-r border-gray-300"
            >
              Error: {error}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default IntrinsicValueTable;
